import { useMemo } from 'react';
import { Modal, Table } from 'react-bootstrap';

const formatMoney = (value) => {
    const v = Number(value || 0);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v);
};

/* Los precios del catálogo siempre llegan en MXN; se muestran convertidos a la moneda
   activa de la venta (misma lógica que ya se aplica al agregar un producto a la tabla). */
export default function PreciosProveedorModal({ show, onHide, productoNombre, codigoTienda, precios, moneda, tipoCambio }) {
    const rows = useMemo(() => (Array.isArray(precios) ? precios : []), [precios]);

    const esUsd = Number(moneda) === 1;
    const tc = esUsd && Number(tipoCambio) > 0 ? Number(tipoCambio) : 1;
    const prefMoneda = esUsd ? 'USD $' : '$';

    const formatPrecio = (value) => `${prefMoneda} ${formatMoney(Number(value || 0) / tc)}`;

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Precios del proveedor</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {(productoNombre || codigoTienda) ? (
                    <div className="text-muted mb-2" style={{ fontSize: 13 }}>
                        {productoNombre ? <span className="fw-semibold">{productoNombre}</span> : null}
                        {codigoTienda ? <span>{productoNombre ? ' · ' : ''}{codigoTienda}</span> : null}
                    </div>
                ) : null}

                <div className="table-responsive">
                    <Table bordered hover className="mb-0">
                        <thead>
                            <tr>
                                <th>Proveedor</th>
                                <th>C. Prov</th>
                                <th>C. INRA</th>
                                <th className="text-end">P. Compra</th>
                                <th className="text-end">P. Público</th>
                                <th className="text-end">P. Mínimo</th>
                                <th className="text-end">P. Liquidación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="text-center text-muted">
                                        Sin precios registrados
                                    </td>
                                </tr>
                            ) : (
                                rows.map((p) => (
                                    <tr key={`${p?.proveedor?._id || 'prov'}-${p?.codigo_proveedor || ''}`}>
                                        <td>{p?.proveedor?.nombre || '-'}</td>
                                        <td>{p?.codigo_proveedor || '-'}</td>
                                        <td>{codigoTienda || '-'}</td>
                                        <td className="text-end">{formatPrecio(p?.precio_historico)}</td>
                                        <td className="text-end">{formatPrecio(p?.precio_publico)}</td>
                                        <td className="text-end">{formatPrecio(p?.precio_minimo)}</td>
                                        <td className="text-end">{formatPrecio(p?.precio_liquidacion)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
}